import General from './General';
import FullWidthLayout from './FullWidthLayout';
import SideLayout from './SideLayout';

interface LayoutProps {
  layout: string;
  [key: string]: any;
}

const Layout = ({ layout, children, ...props }: LayoutProps) => {
  switch (layout) {
    case 'sideLayout':
      return <SideLayout {...props}>{children}</SideLayout>;
    case 'fullWidthLayout':
      return <FullWidthLayout {...props}>{children}</FullWidthLayout>;
    case 'fullWidthLayoutPublic':
      return (
        <FullWidthLayout {...props} hideNavbar hideHeader>
          {children}
        </FullWidthLayout>
      );
    case 'general':
    default:
      return <General {...props}>{children}</General>;
  }
};

export default Layout;
